import { CloseOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import INFO_ICON from "@/resource/images/png/lightning/Info_Icon.svg";
import IF from "@/components/IF";
import "./index.less";
import LightingInvokeButton from "../LightningButton/LightningInvokeButton";

const LightningDrawOnMap = () => {
    const [noticeVisible, setNoticeVisible] = useState<boolean>(true);
    return(
        <div className="lightning-drawOnMap">
            <div className="lightning-drawOnMap-content">
                <IF show={noticeVisible}>
                    <div className="lightning-drrawOnMap-warning-div">
                        <div className="icon-wrapper">
                            <img
                                src={INFO_ICON}
                                style={{ color: "#16a34a", fontSize: "16px" }}
                            />
                        </div>
                        <span>
                                        Here you can draw polygon or circle selection. Use Rectangle or
                                        Circle buttons on the map to draw.
                        </span>
                        {/* <div className="close-button">
                            <CloseOutlined
                                onClick={() => {
                                    setNoticeVisible(false);
                                }}
                            />
                        </div> */}
                    </div>
                </IF>
            </div>

            <div className="lightning-drawOnMap-button">
                <LightingInvokeButton />
            </div>
        </div>
    );
};


export default LightningDrawOnMap;